import { Api as api } from "../api";
const prefix = '/auth'
// const prefix = ''
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    authServiceV1Login: build.mutation<
      AuthServiceV1LoginApiResponse,
      AuthServiceV1LoginApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/login`,
        method: "POST",
        body: queryArg.authLoginReq,
      }),
    }),
    authServiceV1GetUserInfo: build.query<
      AuthServiceV1GetUserInfoApiResponse,
      AuthServiceV1GetUserInfoApiArg
    >({
      query: () => ({ url: `${prefix}/v1/my` }),
    }),
    authServiceV1BulkCreateLocalProviders: build.mutation<
      AuthServiceV1BulkCreateLocalProvidersApiResponse,
      AuthServiceV1BulkCreateLocalProvidersApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/providers/local/bulk`,
        method: "POST",
        body: queryArg.authBulkCreateLocalProvidersReq,
      }),
    }),
    authServiceV1Register: build.mutation<
      AuthServiceV1RegisterApiResponse,
      AuthServiceV1RegisterApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/register`,
        method: "POST",
        body: queryArg.authRegisterReq,
      }),
    }),
    authServiceV1ResendConfirmationEmail: build.mutation<
      AuthServiceV1ResendConfirmationEmailApiResponse,
      AuthServiceV1ResendConfirmationEmailApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/resend-confirmation-email`,
        method: "POST",
        body: queryArg.authResendConfirmationReq,
      }),
    }),
    authServiceV1VerifyEmail: build.mutation<
      AuthServiceV1VerifyEmailApiResponse,
      AuthServiceV1VerifyEmailApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/verify-email`,
        method: "POST",
        body: queryArg.authVerifyEmailReq,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as authApi };
export type AuthServiceV1LoginApiResponse =
  /** status 200 A successful response. */ AuthLoginRes;
export type AuthServiceV1LoginApiArg = {
  authLoginReq: AuthLoginReq;
};
export type AuthServiceV1GetUserInfoApiResponse =
  /** status 200 A successful response. */ AuthGetUserInfoRes;
export type AuthServiceV1GetUserInfoApiArg = void;
export type AuthServiceV1BulkCreateLocalProvidersApiResponse =
  /** status 200 A successful response. */ AuthBulkCreateLocalProvidersRes;
export type AuthServiceV1BulkCreateLocalProvidersApiArg = {
  authBulkCreateLocalProvidersReq: AuthBulkCreateLocalProvidersReq;
};
export type AuthServiceV1RegisterApiResponse =
  /** status 200 A successful response. */ AuthRegisterRes;
export type AuthServiceV1RegisterApiArg = {
  authRegisterReq: AuthRegisterReq;
};
export type AuthServiceV1ResendConfirmationEmailApiResponse =
  /** status 200 A successful response. */ AuthResendConfirmationRes;
export type AuthServiceV1ResendConfirmationEmailApiArg = {
  authResendConfirmationReq: AuthResendConfirmationReq;
};
export type AuthServiceV1VerifyEmailApiResponse =
  /** status 200 A successful response. */ AuthVerifyEmailRes;
export type AuthServiceV1VerifyEmailApiArg = {
  authVerifyEmailReq: AuthVerifyEmailReq;
};
export type AuthLoginRes = {
  message?: string;
  access_token?: string;
};
export type ProtobufAny = {
  "@type"?: string;
  [key: string]: any;
};
export type RpcStatus = {
  code?: number;
  message?: string;
  details?: ProtobufAny[];
};
export type AuthLoginReq = {
  email: string;
  password: string;
};
export type AuthGetUserInfoRes = {
  role_code?: string;
  permissions?: object;
  module_access?: object;
};
export type AuthBulkCreateLocalProvidersRes = {
  inserted_count?: number;
  message?: string;
};
export type AuthLocalProviderItem = {
  user_id: string;
  email: string;
  photo_url?: string;
  permissions?: object;
};
export type AuthBulkCreateLocalProvidersReq = {
  providers: AuthLocalProviderItem[];
};
export type AuthRegisterRes = {
  message?: string;
  user_id?: string;
};
export type AuthRegisterReq = {
  username: string;
  email: string;
  phone_number?: string;
  password: string;
  confirm_password: string;
  invitation_id?: string;
};
export type AuthResendConfirmationRes = {
  message?: string;
};
export type AuthResendConfirmationReq = {
  user_id: string;
};
export type AuthVerifyEmailRes = {
  message?: string;
};
export type AuthVerifyEmailReq = {
  token: string;
};
export const {
  useAuthServiceV1LoginMutation,
  useAuthServiceV1GetUserInfoQuery,
  useAuthServiceV1BulkCreateLocalProvidersMutation,
  useAuthServiceV1RegisterMutation,
  useAuthServiceV1ResendConfirmationEmailMutation,
  useAuthServiceV1VerifyEmailMutation,
} = injectedRtkApi;
